import React from "react";
import { BeatLoader } from "react-spinners";

export default function Loading({ background_color }) {
  switch (background_color) {
    case "white":
      background_color = "background-white";
      break;
    default:
      background_color = "background-custom";
      break;
  }

  return (
    <div className={`loading-screen ${background_color}`}>
      <div
        className={`loading d-flex align-items-center justify-content-center text-center`}
      >
        <BeatLoader color="#df2020" />
      </div>
    </div>
  );
}
